let APP_CONFIG;

export let setAppConfig = (config) => {
    APP_CONFIG = config
}

export let getAppConfig = () => APP_CONFIG
